import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import ContactPage from "../views/ContactPage.vue";
import PurchasePage from "../views/PurchasePage.vue";
import MotoSaleForm from "../views/MotoSaleForm.vue";
import AutoSaleForm from "../views/AutoSaleForm.vue";
import MotoPurchaseForm from "../views/MotoPurchaseForm.vue";
import AutoPurchaseForm from "../views/AutoPurchaseForm.vue";
import SalePage from "../views/SalePage.vue";
import GeneralTerms from "../views/GeneralTerms.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import SuccessPage from "../views/SuccessPage.vue";
import SellAutoIntPage from "../views/SellAutoInt.vue";
import SellMotoIntPage from "../views/SellMotoInt.vue";

//import { localizedPath } from '@/utiles/localizedPath';

import NotFound from "../views/404.vue";
import "../assets/style.css"; // Import the global CSS file
import i18n from "@/i18n";

// Grouping routes by language
const deRoutes = [
  {
    path: "/:locale(de)/startseite",
    name: "Startseite",
    component: HomePage,
    meta: { title: "Startseite - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(de)/kontakt",
    name: "Kontakt",
    component: ContactPage,
    meta: { title: "Kontakt - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(de)/ankauf",
    name: "Ankauf",
    component: PurchasePage,
    meta: { title: "Ankauf - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(de)/motorrad-verkauf",
    name: "MotorradVerkauf",
    component: MotoSaleForm,
    meta: { title: "Motorrad Verkauf - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(de)/auto-verkauf",
    name: "AutoVerkauf",
    component: AutoSaleForm,
    meta: { title: "Auto Verkauf - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(de)/motorrad-ankauf",
    name: "MotorradAnkauf",
    component: MotoPurchaseForm,
    meta: { title: "Motorrad Ankauf - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(de)/auto-ankauf",
    name: "AutoAnkauf",
    component: AutoPurchaseForm,
    meta: { title: "Auto Ankauf - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(de)/verkauf",
    name: "Verkauf",
    component: SalePage,
    meta: { title: "Verkauf - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(de)/agb",
    name: "AGB",
    component: GeneralTerms,
    meta: {
      title: "Allgemeine Geschäftsbedingungen - AS Auto Moto Sales GmbH",
    },
  },
  {
    path: "/:locale(de)/datenschutz",
    name: "Datenschutz",
    component: PrivacyPolicy,
    meta: { title: "Datenschutzerklärung - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(de)/erfolgsseite",
    name: "SuccessPageDE",
    component: SuccessPage,
    meta: { title: "Erfolgsseite - AS Auto Moto Sales GmbH" },
  },
  {
    "path": "/:locale(de)/auto-verkaufsinfo",
    "name": "AutoSaleInfoDE",
    "component": SellAutoIntPage,
    "meta": { "title": "Auto Verkaufsinformationen - AS Auto Moto Sales GmbH" }
  },
  {
    "path": "/:locale(de)/moto-verkaufsinfo",
    "name": "MotoSaleInfoDE",
    "component": SellMotoIntPage,
    "meta": { "title": "Moto Verkaufsinformationen - AS Auto Moto Sales GmbH" }
  }
];

const enRoutes = [
  {
    path: "/:locale(en)/home",
    name: "Home",
    component: HomePage,
    meta: { title: "Home - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/contact",
    name: "Contact",
    component: ContactPage,
    meta: { title: "Contact - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/purchase",
    name: "Purchase",
    component: PurchasePage,
    meta: { title: "Purchase - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/moto-sale",
    name: "MotoSale",
    component: MotoSaleForm,
    meta: { title: "Moto Sale - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/auto-sale",
    name: "AutoSale",
    component: AutoSaleForm,
    meta: { title: "Auto Sale - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/moto-purchase",
    name: "MotoPurchase",
    component: MotoPurchaseForm,
    meta: { title: "Moto Purchase - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/auto-purchase",
    name: "AutoPurchase",
    component: AutoPurchaseForm,
    meta: { title: "Auto Purchase - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/sale",
    name: "Sale",
    component: SalePage,
    meta: { title: "Sale - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/terms",
    name: "Terms",
    component: GeneralTerms,
    meta: { title: "General Terms and Conditions - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: { title: "Privacy Policy - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/success-page",
    name: "SuccessPageEN",
    component: SuccessPage,
    meta: { title: "Success Page - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/auto-sale-info",
    name: "AutoSaleInfo",
    component: SellAutoIntPage,
    meta: { title: "Auto Sale Info - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(en)/moto-sale-info",
    name: "MotoSaleInfo",
    component: SellMotoIntPage,
    meta: { title: "Moto Sale Info - AS Auto Moto Sales GmbH" },
  }
];

const frRoutes = [
  {
    path: "/:locale(fr)/accueil",
    name: "Accueil",
    component: HomePage,
    meta: { title: "Accueil - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(fr)/contact",
    name: "ContactFR",
    component: ContactPage,
    meta: { title: "Contact - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(fr)/vente",
    name: "Vente",
    component: PurchasePage,
    meta: { title: "Vente - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(fr)/vente-moto",
    name: "MotoSaleFR",
    component: MotoSaleForm,
    meta: { title: "Vente Moto - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(fr)/vente-auto",
    name: "AutoSaleFR",
    component: AutoSaleForm,
    meta: { title: "Vente Auto - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(fr)/achat-moto",
    name: "MotoPurchaseFR",
    component: MotoPurchaseForm,
    meta: { title: "Achat Moto - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(fr)/achat-auto",
    name: "AutoPurchaseFR",
    component: AutoPurchaseForm,
    meta: { title: "Achat Auto - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(fr)/vente-generale",
    name: "SaleFR",
    component: SalePage,
    meta: { title: "Vente Generale - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(fr)/conditions-generales",
    name: "ConditionsGenerales",
    component: GeneralTerms,
    meta: { title: "Conditions Générales - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(fr)/politique-de-confidentialite",
    name: "PrivacyPolicyFR",
    component: PrivacyPolicy,
    meta: { title: "Politique de Confidentialité - AS Auto Moto Sales GmbH" },
  },
  {
    path: "/:locale(fr)/page-de-succes",
    name: "SuccessPageFR",
    component: SuccessPage,
    meta: { title: "Page de succès - AS Auto Moto Sales GmbH" },
  },
    {
    "path": "/:locale(fr)/info-vente-auto",
    "name": "AutoSaleInfoFR",
    "component": SellAutoIntPage,
    "meta": { "title": "Auto Vente - AS Auto Moto Sales GmbH" }
  },
  {
    "path": "/:locale(fr)/info-vente-moto",
    "name": "MotoSaleInfoFR",
    "component": SellMotoIntPage,
    "meta": { "title": "Moto Vente - AS Auto Moto Sales GmbH" }
  }
];

// Combine all routes
const routes = [
  ...deRoutes,
  ...enRoutes,
  ...frRoutes,
  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
  { path: "/", redirect: "/de/startseite" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

// Update the title dynamically
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "AS Auto Moto Sales GmbH";
  const supportedLocales = ["en", "de", "fr"];
  const currentLocale = i18n.global.locale?.value || "de";
  const pathLocale = to.params.locale || currentLocale;

  if (!supportedLocales.includes(pathLocale)) {
    return next(`/${currentLocale}${to.path.replace(/^\/[\w-]+/, "")}`);
  }

  if (pathLocale !== currentLocale) {
    i18n.global.locale = pathLocale;
  }
  /*const updatedPath = localizedPath(to.name);
  if (updatedPath !== to.fullPath) {
    console.log(`🔄 Redirecting to correct localized path: ${updatedPath}`);
    return next(updatedPath);
  }*/

  next();
});

export default router;
